import React, {forwardRef} from "react";
import classNames from "classnames";
import css from "./DrawerBody.module.scss";

/**
 * The area for the drawer's main content.
 *
 * Unlike the <DrawerHeader /> and <DrawerFooter /> components,
 * we do not render <DrawerContent /> components in here so that
 * we can allow developers to define their own drawer sections
 * within the body area.
 */
const DrawerBody = forwardRef(({children, className, ...rest}, ref) => {
  return (
    <div
      ref={ref}
      className={classNames(css.drawerBodyContent, className)}
      {...rest}>
      {children}
    </div>
  );
});

export default DrawerBody;
